import { asyncPipeSpread } from 'lib/util'
import find from 'lib/sequence/component/children/find'
import swapListSerialAndName from 'app/_shared/action/partial/swapListSerialAndName'

/**
 * Request Index Action
 *
 * @param {Gaia.AppModule.Spec} module  current module
 * @returns {function(*): function(...[*]): Promise<*>}
 */
export default module => component => async (...args) => asyncPipeSpread(
  swapListSerialAndName(module),
)(find(component), ...args)
